export const ASSISTANT_MARKDOWN_ALLOWED_ELEMENTS = [
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  // eslint-disable-next-line spellcheck/spell-checker -- Standard HTML element names.
  "blockquote",
  "code",
  "pre",
  "a",
  "hr",
  // eslint-disable-next-line spellcheck/spell-checker -- Standard HTML element names.
  "br",
];
